import React from "react";
import { Link, withRouter } from "react-router-dom";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Gravatar from "react-gravatar";

const CustomerCard = ({ first_name, last_name, email, id }) => {
  return (
    <Card bg="light" style={{ minWidth: "250px", maxWidth: "250px" }}>
      <Card.Header>{id}</Card.Header>
      <Gravatar
        default={"wavatar"}
        email={email}
        size={250}
        className="card-img-top"
      />
      <Card.Body>
        <Card.Title>
          {first_name} <br></br>
          {last_name}
        </Card.Title>
        <Card.Text></Card.Text>
        <Link to={`/customers/${id}`}>
          <Button variant="primary">View Customer</Button>
        </Link>
      </Card.Body>
    </Card>
  );
};

export default CustomerCard;
